export default __webpack_public_path__ + "cac9a7c.png";